'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00245 from "./presto.-Login-Page-View$$anon$5.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$Mode$(outer) {
  this.XB = null;
  this.a8u = null;
  this.b7H = null;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.b7H = outer;
  this.XB = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00245.$c_Lpresto_LoginPageView$$anon$5(0, "Login", this);
  this.a8u = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00245.$c_Lpresto_LoginPageView$$anon$5(1, "EmailLink", this);
}
export { $c_Lpresto_LoginPageView$Mode$ as $c_Lpresto_LoginPageView$Mode$ };
$p = $c_Lpresto_LoginPageView$Mode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$Mode$;
/** @constructor */
function $h_Lpresto_LoginPageView$Mode$() {
}
export { $h_Lpresto_LoginPageView$Mode$ as $h_Lpresto_LoginPageView$Mode$ };
$h_Lpresto_LoginPageView$Mode$.prototype = $p;
var $d_Lpresto_LoginPageView$Mode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$Mode$, "presto.LoginPageView$Mode$", ({
  Mp: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_LoginPageView$Mode$ as $d_Lpresto_LoginPageView$Mode$ };
//# sourceMappingURL=presto.-Login-Page-View$-Mode$.js.map
